<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="documentType.title"
          :link="[
            {
              text: 'Văn bản chỉ đạo',
              href: '../directiveDocumentTypes'
            }
          ]"
        />
      </div>
      <div class="flex-center" v-if="role.type !== 'teacher' && role.type !== 'inspector'">
        <v-btn color="primary" class="elevation-0" @click="upload">
          <span>Upload tệp</span>
          <input ref="uploader" type="file" class="d-none" accept=".pdf, .xlsx, .doc, .docx" @change="onFileChanged" />
        </v-btn>
      </div>
    </div>

    <!-- <div v-if="role.type !== 'teacher'">
      <v-card class="mx-4 mb-6 pa-6" outlined>
        <v-row>
          <v-col cols="12" md="6">
            <AutocompleteTeacherCard
              v-model="teacher"
              item-text="name"
              clear-icon="mdi-close"
              label="Giáo viên"
              outlined
              dense
              deletable-chips
              hide-details
              :displaySubjectGroup="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-btn height="40" color="#0D47A1" @click="search" outlined>
              Chọn xem
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </div> -->
    <v-card outlined class="mx-4 elevation-0">
      <DirectiveDocumentDataTable ref="table" />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapGetters } from 'vuex'
import DirectiveDocumentDataTable from '@/modules/document/DirectiveDocumentDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    DirectiveDocumentDataTable
  },
  data() {
    return {
      isSelecting: false,
      typeId: '',
      teacher: {},
      documentType: {},
      selecteds: []
    }
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role', 'user'])
  },
  async created() {
    this.typeId = this.$route.params.id
    this.documentType = await this.fetchDocumentType(this.typeId)
  },
  methods: {
    ...mapActions('Documents', ['createDocument', 'removeDocument', 'removeDocuments', 'fetchDocumentType']),
    ...mapActions('upload', ['uploadFile']),

    upload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      if (this.role.type !== 'teacher') {
        this.$loading.active = true
        const file = e.target.files[0]

        let createdDocument = {}
        try {
          console.log(this.user, this.profile, this.content)
          // create document
          const data = {
            documentType: this.typeId,
            createdTeacher: this.profile.id,
            createdUser: this.user.id
          }
          createdDocument = await this.createDocument(data)
          // upload file
          let formData = new FormData()
          formData.append('files', file)
          formData.append('refId', createdDocument.id)
          formData.append('ref', 'document')
          formData.append('field', 'file')

          await this.uploadFile(formData)

          this.$alert.success('Tải file thành công')
          await this.$refs.table.refresh({ documentType: this.typeId })
        } catch (error) {
          this.$alert.error('Tải file thất bại, vui lòng thử lại. Lỗi: ' + error)
          if (createdDocument.id) await this.removeDocument(createdDocument.id)
        } finally {
          this.$loading.active = false
        }
      }
    },
    async search() {
      await this.$refs.table.refresh({ documentType: this.typeId })
    },
    async removeFiles() {
      this.$dialog.confirm({
        title: 'Xóa tài liệu',
        text: `Bạn có Chắc Chắn muốn xóa ${this.selecteds && this.selecteds.length} tài liệu này không ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.removeDocuments(this.selecteds.map(f => f.id))
            await this.search()
            this.$alert.deleteSuccess()
            this.selecteds = []
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
<style scoped></style>
